export const INSIGHTS_ACTIVITY_MAP_FETCHER_ACTIONS = {
    FETCH_ACTIVITY_MAP_DATA_SUCCESS: 'FETCH_ACTIVITY_MAP_DATA_SUCCESS',
    FETCH_ACTIVITY_MAP_DATA_FAILURE: 'FETCH_ACTIVITY_MAP_DATA_FAILURE',
    FETCHING_ACTIVITY_MAP_DATA: 'FETCHING_ACTIVITY_MAP_DATA'
};

export const INSIGHTS_ACTIVITY_MAP_CHART_ACTIONS = {
    UPDATE_CONTROL: 'ACTIVITY_MAP_UPDATE_CONTROL'
};

export function updateControl(payload) {
    return {
        type: INSIGHTS_ACTIVITY_MAP_CHART_ACTIONS.UPDATE_CONTROL,
        payload
    }
};

export function activityMapChartLoading(){
    return{
        type : INSIGHTS_ACTIVITY_MAP_FETCHER_ACTIONS.FETCHING_ACTIVITY_MAP_DATA
    }
};
